/**
  Experimental new component - will move to UCL if this is successful
*/

import { Spinner } from '@salecycle/ui-component-library';
import { JustifyContentType, AlignItemsType } from '../ComponentTypes';
import styled from 'styled-components';

interface Props {
  maxWidth?: string;
  columnMinWidth?: string;
  columnMaxWidth?: string;
  numColumns?: number;
  isLoading?: boolean;
  hideSpinner?: boolean;
  justifyContent?: JustifyContentType;
  justifySelf?: JustifyContentType;
  alignItems?: AlignItemsType;
}

const SectionElement = styled.div<Props>``;

const ContentAreaElement = styled.div<Props>`
  display: grid;
  max-width: ${props => props.maxWidth};
  justify-content: ${props => props.justifyContent};
  justify-self: ${props => props.justifySelf};
  align-items: ${props => props.alignItems};
  grid-template-columns: repeat(
    ${props => (props.numColumns ? props.numColumns : 'auto-fit')},
    minmax(${props => props.columnMinWidth + ', ' + props.columnMaxWidth})
  );
  gap: 20px 30px;
`;

const HeadingArea = styled.div<Props>`
  font-size: 24px;
  font-weight: bold;
  grid-area: heading-area;
  align-self: center;
  margin-bottom: 20px;
`;

const SpinnerWrapper = styled.div<Props>`
  height: 100%;
  max-width: ${props => props.maxWidth};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export function Section({ children, ...props }: any) {
  return (
    <SectionElement data-testid="Section">
      {!props.isLoading && props.heading && <HeadingArea>{props.heading}</HeadingArea>}
      {props.isLoading && !props.hideSpinner && (
        <SpinnerWrapper {...props}>
          <Spinner />
        </SpinnerWrapper>
      )}
      <ContentAreaElement {...props}>{!props.isLoading && children}</ContentAreaElement>
    </SectionElement>
  );
}

const defaultProps: Props = {
  columnMinWidth: '250px',
  columnMaxWidth: '1fr',
};

Section.defaultProps = defaultProps;
